// Thank-you phrases for supporter tooltips, organized by category and language.
// Excluded from SonarCloud duplication analysis (translation data, not logic).

interface ThankYouPhrases {
  [category: string]: {
    [lang: string]: string[];
  };
}

export const THANK_YOU_PHRASES: ThankYouPhrases = {
  regular: {
    en: [
      "Thank you for your support! ☕",
      "You make the difference! 🎵",
      "Thanks a lot! 💙",
      "Super cool of you! 🚀",
      "You rock! 🎸",
      "Thanks for being here! 🙌",
      "You're awesome! ⭐",
      "Heartfelt thanks! ❤️",
      "You help us forward! 🌟",
      "Thanks for your support! 💪",
      "You're the hammer! 🔨",
      "Many thanks! 🎉",
      "You're great! 🌈",
      "Thanks for joining! 🤝",
      "You're a hero! 🦸",
      "Thanks for the coffee! ☕",
      "You're fantastic! 👏",
      "Many thanks! 🎁",
      "You make it possible! ✨",
      "Thanks, you legend! 🏆",
    ],
    de: [
      "Danke für deine Unterstützung! ☕",
      "Du machst den Unterschied! 🎵",
      "Vielen Dank! 💙",
      "Mega cool von dir! 🚀",
      "Du rockst! 🎸",
      "Danke, dass du dabei bist! 🙌",
      "Du bist awesome! ⭐",
      "Herzlichen Dank! ❤️",
      "Du hilfst uns weiter! 🌟",
      "Danke für deinen Support! 💪",
      "Du bist der Hammer! 🔨",
      "Vielen lieben Dank! 🎉",
      "Du bist großartig! 🌈",
      "Danke fürs Mitmachen! 🤝",
      "Du bist ein Held! 🦸",
      "Danke für den Kaffee! ☕",
      "Du bist klasse! 👏",
      "Vielen Dank dafür! 🎁",
      "Du machst's möglich! ✨",
      "Danke, du Ehrenmensch! 🏆",
    ],
    es: [
      "¡Gracias por tu apoyo! ☕",
      "¡Marcas la diferencia! 🎵",
      "¡Muchas gracias! 💙",
      "¡Genial de tu parte! 🚀",
      "¡Eres genial! 🎸",
      "¡Gracias por estar aquí! 🙌",
      "¡Eres increíble! ⭐",
      "¡Gracias de corazón! ❤️",
      "¡Nos ayudas a avanzar! 🌟",
      "¡Gracias por tu ayuda! 💪",
      "¡Eres un crack! 🔨",
      "¡Mil gracias! 🎉",
      "¡Eres fantástico! 🌈",
      "¡Gracias por sumarte! 🤝",
      "¡Eres un héroe! 🦸",
      "¡Gracias por el café! ☕",
      "¡Eres espectacular! 👏",
      "¡Muchísimas gracias! 🎁",
      "¡Lo haces posible! ✨",
      "¡Gracias, leyenda! 🏆",
    ],
    fr: [
      "Merci pour ton soutien ! ☕",
      "Tu fais la différence ! 🎵",
      "Un grand merci ! 💙",
      "Trop cool de ta part ! 🚀",
      "Tu assures ! 🎸",
      "Merci d'être là ! 🙌",
      "Tu es formidable ! ⭐",
      "Merci du fond du cœur ! ❤️",
      "Tu nous fais avancer ! 🌟",
      "Merci pour ton aide ! 💪",
      "Tu es au top ! 🔨",
      "Mille mercis ! 🎉",
      "Tu es génial·e ! 🌈",
      "Merci de participer ! 🤝",
      "Tu es un héros ! 🦸",
      "Merci pour le café ! ☕",
      "Tu es fantastique ! 👏",
      "Merci beaucoup ! 🎁",
      "Tu rends ça possible ! ✨",
      "Merci, légende ! 🏆",
    ],
    it: [
      "Grazie per il tuo supporto! ☕",
      "Fai la differenza! 🎵",
      "Mille grazie! 💙",
      "Troppo forte! 🚀",
      "Sei un grande! 🎸",
      "Grazie di essere qui! 🙌",
      "Sei fantastico! ⭐",
      "Grazie di cuore! ❤️",
      "Ci aiuti ad andare avanti! 🌟",
      "Grazie per il tuo aiuto! 💪",
      "Sei un mito! 🔨",
      "Grazie mille! 🎉",
      "Sei eccezionale! 🌈",
      "Grazie per unirti a noi! 🤝",
      "Sei un eroe! 🦸",
      "Grazie per il caffè! ☕",
      "Sei spettacolare! 👏",
      "Tantissime grazie! 🎁",
      "Lo rendi possibile! ✨",
      "Grazie, leggenda! 🏆",
    ],
    ja: [
      "ご支援ありがとうございます！☕",
      "あなたが違いを生み出します！🎵",
      "感謝します！💙",
      "すごくクール！🚀",
      "最高です！🎸",
      "参加してくれてありがとう！🙌",
      "素晴らしい！⭐",
      "心から感謝！❤️",
      "前進の力になります！🌟",
      "サポートに感謝！💪",
      "あなたは最強！🔨",
      "本当にありがとう！🎉",
      "あなたは素敵！🌈",
      "一緒にいてくれて感謝！🤝",
      "あなたはヒーロー！🦸",
      "コーヒーありがとう！☕",
      "ファンタスティック！👏",
      "深く感謝します！🎁",
      "あなたのおかげです！✨",
      "ありがとう、レジェンド！🏆",
    ],
    nl: [
      "Bedankt voor je steun! ☕",
      "Jij maakt het verschil! 🎵",
      "Heel erg bedankt! 💙",
      "Supergaaf van je! 🚀",
      "Je bent geweldig! 🎸",
      "Bedankt dat je erbij bent! 🙌",
      "Je bent awesome! ⭐",
      "Hartelijk dank! ❤️",
      "Je helpt ons verder! 🌟",
      "Bedankt voor je hulp! 💪",
      "Je bent top! 🔨",
      "Duizendmaal dank! 🎉",
      "Je bent fantastisch! 🌈",
      "Bedankt voor het meedoen! 🤝",
      "Je bent een held! 🦸",
      "Bedankt voor de koffie! ☕",
      "Je bent super! 👏",
      "Ontzettend bedankt! 🎁",
      "Jij maakt het mogelijk! ✨",
      "Bedankt, legende! 🏆",
    ],
    pl: [
      "Dziękujemy za wsparcie! ☕",
      "Robisz różnicę! 🎵",
      "Wielkie dzięki! 💙",
      "Super z twojej strony! 🚀",
      "Jesteś świetny! 🎸",
      "Dzięki, że jesteś! 🙌",
      "Jesteś niesamowity! ⭐",
      "Serdeczne dzięki! ❤️",
      "Pomagasz nam iść dalej! 🌟",
      "Dzięki za pomoc! 💪",
      "Jesteś mega! 🔨",
      "Tysiąc dzięki! 🎉",
      "Jesteś wspaniały! 🌈",
      "Dzięki za dołączenie! 🤝",
      "Jesteś bohaterem! 🦸",
      "Dzięki za kawę! ☕",
      "Jesteś fantastyczny! 👏",
      "Bardzo dziękujemy! 🎁",
      "Ty to umożliwiasz! ✨",
      "Dzięki, legendo! 🏆",
    ],
    pt: [
      "Obrigado pelo apoio! ☕",
      "Você faz a diferença! 🎵",
      "Muito obrigado! 💙",
      "Demais da sua parte! 🚀",
      "Você é incrível! 🎸",
      "Obrigado por estar aqui! 🙌",
      "Você é fantástico! ⭐",
      "Obrigado de coração! ❤️",
      "Você nos ajuda a avançar! 🌟",
      "Obrigado pela ajuda! 💪",
      "Você é fera! 🔨",
      "Milhões de agradecimentos! 🎉",
      "Você é maravilhoso! 🌈",
      "Obrigado por participar! 🤝",
      "Você é um herói! 🦸",
      "Obrigado pelo café! ☕",
      "Você é espetacular! 👏",
      "Muitíssimo obrigado! 🎁",
      "Você torna possível! ✨",
      "Obrigado, lenda! 🏆",
    ],
    sv: [
      "Tack för ditt stöd! ☕",
      "Du gör skillnad! 🎵",
      "Tusen tack! 💙",
      "Supercoolt av dig! 🚀",
      "Du rockar! 🎸",
      "Tack för att du finns! 🙌",
      "Du är fantastisk! ⭐",
      "Hjärtligt tack! ❤️",
      "Du hjälper oss framåt! 🌟",
      "Tack för din hjälp! 💪",
      "Du är grym! 🔨",
      "Stort tack! 🎉",
      "Du är underbar! 🌈",
      "Tack för att du är med! 🤝",
      "Du är en hjälte! 🦸",
      "Tack för kaffet! ☕",
      "Du är enastående! 👏",
      "Tusentals tack! 🎁",
      "Du gör det möjligt! ✨",
      "Tack, legend! 🏆",
    ],
  },
  monthly: {
    en: [
      "You're a champion! 🏆💛",
      "Thanks for your loyal support! ✨",
      "You're worth gold! 💰",
      "Wow, thanks for the monthly commitment! 🌟",
      "You're absolutely amazing! 🚀",
      "Thanks for being here every month! 💙",
      "You're a superhero! 🦸‍♂️",
      "Many thanks for your loyalty! 🙏",
      "You make the project possible! 🎉",
      "Thanks for your continuous help! 💪",
      "You're simply fantastic! ⭐",
      "Heartfelt thanks for your loyalty! ❤️",
      "You're priceless! 💎",
      "Thanks for the monthly fuel! ⚡",
      "You're a rockstar! 🎸",
    ],
    de: [
      "Du bist ein Champion! 🏆💛",
      "Danke für deine treue Unterstützung! ✨",
      "Du bist Gold wert! 💰",
      "Wow, danke fürs monatliche Commitment! 🌟",
      "Du bist der absolute Wahnsinn! 🚀",
      "Danke, dass du jeden Monat dabei bist! 💙",
      "Du bist ein Superheld! 🦸‍♂️",
      "Vielen Dank für deine Treue! 🙏",
      "Du machst das Projekt möglich! 🎉",
      "Danke für deine kontinuierliche Hilfe! 💪",
      "Du bist einfach fantastisch! ⭐",
      "Herzlichen Dank für deine Loyalität! ❤️",
      "Du bist unbezahlbar! 💎",
      "Danke fürs monatliche Fuel! ⚡",
      "Du bist ein Rockstar! 🎸",
    ],
    es: [
      "¡Eres un campeón! 🏆💛",
      "¡Gracias por tu apoyo fiel! ✨",
      "¡Vales oro! 💰",
      "¡Gracias por el compromiso mensual! 🌟",
      "¡Eres absolutamente increíble! 🚀",
      "¡Gracias por estar cada mes! 💙",
      "¡Eres un superhéroe! 🦸‍♂️",
      "¡Mil gracias por tu lealtad! 🙏",
      "¡Haces posible el proyecto! 🎉",
      "¡Gracias por tu ayuda continua! 💪",
      "¡Eres simplemente fantástico! ⭐",
      "¡Gracias de corazón por tu fidelidad! ❤️",
      "¡No tienes precio! 💎",
      "¡Gracias por la energía mensual! ⚡",
      "¡Eres una estrella de rock! 🎸",
    ],
    fr: [
      "Tu es un champion ! 🏆💛",
      "Merci pour ton soutien fidèle ! ✨",
      "Tu vaux de l'or ! 💰",
      "Merci pour l'engagement mensuel ! 🌟",
      "Tu es absolument incroyable ! 🚀",
      "Merci d'être là chaque mois ! 💙",
      "Tu es un super-héros ! 🦸‍♂️",
      "Mille mercis pour ta fidélité ! 🙏",
      "Tu rends le projet possible ! 🎉",
      "Merci pour ton aide continue ! 💪",
      "Tu es tout simplement fantastique ! ⭐",
      "Merci du fond du cœur pour ta loyauté ! ❤️",
      "Tu n'as pas de prix ! 💎",
      "Merci pour le carburant mensuel ! ⚡",
      "Tu es une rockstar ! 🎸",
    ],
    it: [
      "Sei un campione! 🏆💛",
      "Grazie per il tuo supporto fedele! ✨",
      "Vali oro! 💰",
      "Grazie per l'impegno mensile! 🌟",
      "Sei assolutamente incredibile! 🚀",
      "Grazie di essere qui ogni mese! 💙",
      "Sei un supereroe! 🦸‍♂️",
      "Mille grazie per la tua fedeltà! 🙏",
      "Rendi possibile il progetto! 🎉",
      "Grazie per il tuo aiuto continuo! 💪",
      "Sei semplicemente fantastico! ⭐",
      "Grazie di cuore per la tua lealtà! ❤️",
      "Sei impagabile! 💎",
      "Grazie per l'energia mensile! ⚡",
      "Sei una rockstar! 🎸",
    ],
    ja: [
      "あなたはチャンピオン！🏆💛",
      "忠実なご支援に感謝！✨",
      "あなたは金の価値！💰",
      "毎月のコミットメントに感謝！🌟",
      "あなたは本当にすごい！🚀",
      "毎月ありがとうございます！💙",
      "あなたはスーパーヒーロー！🦸‍♂️",
      "変わらぬ忠誠に深く感謝！🙏",
      "プロジェクトを可能にしてくれます！🎉",
      "継続的なご支援に感謝！💪",
      "あなたは素晴らしい！⭐",
      "心からの感謝を！❤️",
      "あなたはかけがえのない存在！💎",
      "毎月のエネルギーに感謝！⚡",
      "あなたはロックスター！🎸",
    ],
    nl: [
      "Je bent een kampioen! 🏆💛",
      "Bedankt voor je trouwe steun! ✨",
      "Je bent goud waard! 💰",
      "Wauw, bedankt voor de maandelijkse steun! 🌟",
      "Je bent absoluut geweldig! 🚀",
      "Bedankt dat je er elke maand bent! 💙",
      "Je bent een superheld! 🦸‍♂️",
      "Heel erg bedankt voor je trouw! 🙏",
      "Jij maakt het project mogelijk! 🎉",
      "Bedankt voor je constante hulp! 💪",
      "Je bent gewoonweg fantastisch! ⭐",
      "Hartelijk dank voor je loyaliteit! ❤️",
      "Je bent onbetaalbaar! 💎",
      "Bedankt voor de maandelijkse brandstof! ⚡",
      "Je bent een rockster! 🎸",
    ],
    pl: [
      "Jesteś mistrzem! 🏆💛",
      "Dzięki za wierne wsparcie! ✨",
      "Jesteś na wagę złota! 💰",
      "Dzięki za miesięczne zaangażowanie! 🌟",
      "Jesteś absolutnie niesamowity! 🚀",
      "Dzięki, że jesteś co miesiąc! 💙",
      "Jesteś superbohaterem! 🦸‍♂️",
      "Ogromne dzięki za lojalność! 🙏",
      "Ty umożliwiasz ten projekt! 🎉",
      "Dzięki za ciągłą pomoc! 💪",
      "Jesteś po prostu fantastyczny! ⭐",
      "Serdeczne dzięki za wierność! ❤️",
      "Jesteś bezcenny! 💎",
      "Dzięki za miesięczne paliwo! ⚡",
      "Jesteś gwiazdą rocka! 🎸",
    ],
    pt: [
      "Você é campeão! 🏆💛",
      "Obrigado pelo apoio fiel! ✨",
      "Você vale ouro! 💰",
      "Obrigado pelo compromisso mensal! 🌟",
      "Você é absolutamente incrível! 🚀",
      "Obrigado por estar aqui todo mês! 💙",
      "Você é um super-herói! 🦸‍♂️",
      "Muito obrigado pela lealdade! 🙏",
      "Você torna o projeto possível! 🎉",
      "Obrigado pela ajuda contínua! 💪",
      "Você é simplesmente fantástico! ⭐",
      "Obrigado de coração pela fidelidade! ❤️",
      "Você não tem preço! 💎",
      "Obrigado pelo combustível mensal! ⚡",
      "Você é uma estrela do rock! 🎸",
    ],
    sv: [
      "Du är en mästare! 🏆💛",
      "Tack för ditt trogna stöd! ✨",
      "Du är värd guld! 💰",
      "Tack för det månatliga engagemanget! 🌟",
      "Du är helt fantastisk! 🚀",
      "Tack för att du finns varje månad! 💙",
      "Du är en superhjälte! 🦸‍♂️",
      "Tusen tack för din lojalitet! 🙏",
      "Du gör projektet möjligt! 🎉",
      "Tack för din ständiga hjälp! 💪",
      "Du är helt enkelt fantastisk! ⭐",
      "Hjärtligt tack för din trohet! ❤️",
      "Du är ovärderlig! 💎",
      "Tack för det månatliga bränslet! ⚡",
      "Du är en rockstjärna! 🎸",
    ],
  },
};
